import React from 'react';

export const MegaphoneIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z"
      fill="#E6F4D7"
    />
    <path
      d="M30.5 28C32.433 28 34 25.0899 34 21.5C34 17.9101 32.433 15 30.5 15M30.5 28C28.567 28 27 25.0899 27 21.5C27 17.9101 28.567 15 30.5 15M30.5 28L17.4435 25.6261C16.5161 25.4575 16.0523 25.3731 15.6773 25.189C14.9145 24.8142 14.3464 24.1335 14.1141 23.3159C14 22.914 14 22.4427 14 21.5C14 20.5573 14 20.086 14.1141 19.6841C14.3464 18.8665 14.9145 18.1858 15.6773 17.811C16.0523 17.6269 16.5161 17.5425 17.4435 17.3739L30.5 15M17 26L17.3939 31.514C17.4313 32.0376 17.45 32.2995 17.5639 32.4979C17.6642 32.6726 17.8149 32.8129 17.9963 32.9005C18.2023 33 18.4648 33 18.9898 33H20.7722C21.3723 33 21.6724 33 21.8945 32.8803C22.0897 32.7751 22.2443 32.6081 22.3342 32.4055C22.4365 32.1749 22.4135 31.8757 22.3675 31.2773L22 26.5"
      stroke="#9DBC60"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ThumbsUpIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z"
      fill="#E6F4D7"
    />
    <g clipPath="url(#clip0_thumbs)">
      <path
        d="M12.6673 22.6668V15.3335M9.33398 16.6668V21.3335C9.33398 22.0699 9.93094 22.6668 10.6673 22.6668H19.6181C20.6053 22.6668 21.4448 21.9466 21.5949 20.9709L22.3128 16.3043C22.4992 15.0928 21.5619 14.0002 20.3361 14.0002H18.0007C17.6325 14.0002 17.334 13.7017 17.334 13.3335V10.9774C17.334 10.0695 16.598 9.3335 15.6901 9.3335C15.4735 9.3335 15.2773 9.46103 15.1894 9.65891L12.8433 14.9376C12.7363 15.1783 12.4975 15.3335 12.2341 15.3335H10.6673C9.93094 15.3335 9.33398 15.9304 9.33398 16.6668Z"
        stroke="#9DBC60"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_thumbs">
        <rect width="16" height="16" fill="white" transform="translate(8 8)" />
      </clipPath>
    </defs>
  </svg>
);

export const DocumentIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.6673 1.89111V5.33323C11.6673 5.79994 11.6673 6.0333 11.7581 6.21156C11.838 6.36836 11.9655 6.49584 12.1223 6.57574C12.3006 6.66656 12.5339 6.66656 13.0007 6.66656H16.4428M13.334 10.8332H6.66732M13.334 14.1665H6.66732M8.33398 7.49984H6.66732M11.6673 1.6665H7.33398C5.93385 1.6665 5.23379 1.6665 4.69901 1.93899C4.2286 2.17867 3.84615 2.56112 3.60647 3.03153C3.33398 3.56631 3.33398 4.26637 3.33398 5.6665V14.3332C3.33398 15.7333 3.33398 16.4334 3.60647 16.9681C3.84615 17.4386 4.2286 17.821 4.69901 18.0607C5.23379 18.3332 5.93385 18.3332 7.33398 18.3332H12.6673C14.0674 18.3332 14.7675 18.3332 15.3023 18.0607C15.7727 17.821 16.1552 17.4386 16.3948 16.9681C16.6673 16.4334 16.6673 15.7333 16.6673 14.3332V6.6665L11.6673 1.6665Z"
      stroke="white"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const EmailIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.66602 5.8335L8.47011 10.5964C9.02109 10.982 9.29658 11.1749 9.59624 11.2496C9.86093 11.3156 10.1378 11.3156 10.4025 11.2496C10.7021 11.1749 10.9776 10.982 11.5286 10.5964L18.3327 5.8335M5.66602 16.6668H14.3327C15.7328 16.6668 16.4329 16.6668 16.9677 16.3943C17.4381 16.1547 17.8205 15.7722 18.0602 15.3018C18.3327 14.767 18.3327 14.067 18.3327 12.6668V7.3335C18.3327 5.93336 18.3327 5.2333 18.0602 4.69852C17.8205 4.22811 17.4381 3.84566 16.9677 3.60598C16.4329 3.3335 15.7328 3.3335 14.3327 3.3335H5.66602C4.26588 3.3335 3.56582 3.3335 3.03104 3.60598C2.56063 3.84566 2.17818 4.22811 1.9385 4.69852C1.66602 5.2333 1.66602 5.93336 1.66602 7.3335V12.6668C1.66602 14.067 1.66602 14.767 1.9385 15.3018C2.17818 15.7722 2.56063 16.1547 3.03104 16.3943C3.56582 16.6668 4.26588 16.6668 5.66602 16.6668Z"
      stroke="white"
      stroke-width="1.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const QuestionIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.09 9C9.3251 8.33167 9.78915 7.76811 10.4 7.40913C11.0108 7.05016 11.7289 6.91894 12.4272 7.03871C13.1255 7.15849 13.7588 7.52152 14.2151 8.06353C14.6713 8.60553 14.9211 9.29152 14.92 10C14.92 12 11.92 13 11.92 13M12 17H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke="#3F621A"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
